export const submitButtonSettings = {
  submitButtonAlignment: 'center',
  submitButtonProps: {
    text: 'Submit',
    mode: 'contain',
    color: 'rgb(25, 123, 255)',
    borderRadius: 4,
    size: 15,
    font: {
      fontSize: 15,
      fontWeight: 'bold',
      fontStyle: 'normal'
    },
    horizontalPadding: 23,
    verticalPadding: 10,
    fullWidth: false
  }
};

export type SubmitButtonSettings = typeof submitButtonSettings;
